import { fetcher } from "helpers/fetcher";

import { TSearchBasicWageJobReq, TSearchBasicWageJobRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const searchBasicWageJob = async (params: TSearchBasicWageJobReq) => {
  return await fetcher<TSearchBasicWageJobRes, TSearchBasicWageJobReq>(
    ENDPOINT.CORPORATION.SEARCH_BASIC_WAGE_JOB,
    {
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.SEARCH_BASIC_WAGE_JOB.version,
      },
      params: params,
    }
  );
};

export const querySearchBasicWageJob = async (
  params: TSearchBasicWageJobReq
) => {
  return (await searchBasicWageJob(params)).data;
};

querySearchBasicWageJob._key = (params: TSearchBasicWageJobReq) => [
  ENDPOINT.CORPORATION.SEARCH_BASIC_WAGE_JOB.url,
  params,
];
